import { render } from "./Lowbar.vue?vue&type=template&id=d0e27998"
import script from "./Lowbar.vue?vue&type=script&lang=ts"
export * from "./Lowbar.vue?vue&type=script&lang=ts"
script.render = render

export default script